import * as React from 'react';
import img from '../BANNER.png';
import { Button, Flex, Radio, Slider, Space } from 'antd';
import logo from 'src/assets/images/banner-logo.svg';

const Banner: React.FC = () => (
  <div className='container'>
    <Flex justify={'space-between'} align={'center'}>
      <Space align="center">
          <a href='#'><img src={logo} alt="csdl" /></a> 
          {/* <h1>THƯ VIỆN ĐIỆN TỬ VỀ CÔNG TÁC DÂN TỘC <br/><span>TRÊN ĐỊA BÀN TỈNH QUẢNG NAM</span></h1> */}
      </Space>
      {/* <a className='qti-login' href='/dang-nhap'>Đăng nhập</a> */}
    </Flex>
      
  </div>
);

// const Banner: React.FC = () => (
//   <div
//     style={{
//       backgroundImage: `url(${img})`,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       height: '300px',
//       marginBottom: '20px',
//       borderRadius: '8px',
//       boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//       overflow: 'hidden',
//     }}
//   >
//     <div
//       style={{
//         backgroundColor: 'rgba(0, 0, 0, 0.3)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         color: '#fff',
//         fontSize: '24px',
//         fontWeight: 'bold',
//         textAlign: 'center',
//         padding: '0 20px',
//       }}
//     >
//       {/* You can add text content here if desired */}
//     </div>
//   </div>
// );

export default Banner;
